import { icon_arrow_right, icon_basket } from '@gn-audio/icons';
import { Button } from '@gn-audio/jss-components';
import { JabraIcon } from '@gn-audio/jss-components';

export const StyleGuideButtons = () => {
  return (
    <div className="w-[950px] p-6">
      <h3 className="mb-4 border-b border-b-gray text-2xl font-bold">Buttons</h3>
      <div>
        <h4>Button variants on light background</h4>
        <div className="flex flex-wrap gap-4">
          <Button variant="primary" size="l">
            primary
          </Button>
          <Button variant="secondary" size="l">
            secondary
          </Button>
          <Button variant="tertiary" size="l">
            tertiary
          </Button>
          <Button variant="quaternary" size="l">
            quaternary
          </Button>
          <Button variant="link" size="l">
            link
          </Button>
        </div>
      </div>

      <div>
        <h4>Button variants with icon</h4>
        <div className="flex flex-wrap gap-4">
          <Button
            variant="primary"
            size="l"
            icon={<JabraIcon Icon={icon_arrow_right} />}
            iconPlacement="right"
          >
            primary
          </Button>
          <Button
            variant="secondary"
            size="l"
            icon={<JabraIcon Icon={icon_basket} />}
            iconPlacement="right"
          >
            secondary
          </Button>
          <Button variant="tertiary" size="l" icon={<div>IC</div>} iconPlacement="right">
            tertiary
          </Button>
          <Button variant="quaternary" size="l" icon={<div>IC</div>} iconPlacement="right">
            quaternary
          </Button>
          <Button variant="link" size="l" icon={<div>IC</div>} iconPlacement="right">
            link
          </Button>
          <Button variant="primary" size="l" icon={<div>IC</div>} iconPlacement="left">
            primary
          </Button>
          <Button variant="secondary" size="l" icon={<div>IC</div>} iconPlacement="left">
            secondary
          </Button>
          <Button variant="tertiary" size="l" icon={<div>IC</div>} iconPlacement="left">
            tertiary
          </Button>
          <Button variant="quaternary" size="l" icon={<div>IC</div>} iconPlacement="left">
            quaternary
          </Button>
          <Button variant="link" size="l" icon={<div>IC</div>} iconPlacement="left">
            link
          </Button>
        </div>
      </div>

      <div className="dark bg-blue-800 py-10">
        <h4>Button variants with icon on dark theme</h4>
        <div className="flex flex-wrap gap-4">
          <Button
            variant="primary"
            size="l"
            icon={<JabraIcon Icon={icon_arrow_right} />}
            iconPlacement="right"
          >
            primary
          </Button>
          <Button
            variant="secondary"
            size="l"
            icon={<JabraIcon Icon={icon_basket} />}
            iconPlacement="right"
          >
            secondary
          </Button>
          <Button variant="tertiary" size="l" icon={<div>IC</div>} iconPlacement="right">
            tertiary
          </Button>
          <Button variant="quaternary" size="l" icon={<div>IC</div>} iconPlacement="right">
            quaternary
          </Button>

          <Button variant="link" size="l" icon={<div>IC</div>} iconPlacement="right">
            link
          </Button>
          <Button variant="primary" size="l" icon={<div>IC</div>} iconPlacement="left">
            primary
          </Button>
          <Button variant="secondary" size="l" icon={<div>IC</div>} iconPlacement="left">
            secondary
          </Button>
          <Button variant="tertiary" size="l" icon={<div>IC</div>} iconPlacement="left">
            tertiary
          </Button>
          <Button variant="quaternary" size="l" icon={<div>IC</div>} iconPlacement="left">
            quaternary
          </Button>

          <Button variant="link" size="l" icon={<div>IC</div>} iconPlacement="left">
            link
          </Button>
        </div>
      </div>

      <div>
        <h4>Icon Buttons</h4>
        <div className="flex flex-wrap gap-4">
          <Button variant="primary" size="l" icon={<div>P</div>} />
          <Button variant="secondary" size="l" icon={<div>S</div>} />
          <Button variant="tertiary" size="l" icon={<div>T</div>} />
          <Button variant="quaternary" size="l" icon={<div>Q</div>} />
          <Button variant="link" size="l" icon={<div>LN</div>} />
        </div>
      </div>
      <div className="dark bg-blue-800 py-10">
        <h4>Icon Buttons on dark theme</h4>
        <div className="flex flex-wrap gap-4">
          <Button variant="primary" size="l" icon={<div>P</div>} />
          <Button variant="secondary" size="l" icon={<div>S</div>} />
          <Button variant="tertiary" size="l" icon={<div>T</div>} />
          <Button variant="quaternary" size="l" icon={<div>Q</div>} />
          <Button variant="link" size="l" icon={<div>LN</div>} />
        </div>
      </div>
      <div>
        <h4>Button sizes</h4>
        <div className="flex flex-wrap gap-4">
          <Button variant="primary" size="l">
            Some text
          </Button>
          <Button variant="primary" size="m">
            Some text
          </Button>
          <Button variant="primary" size="s">
            Some text
          </Button>
          <Button variant="primary" size="l" icon={<div>IC</div>} />
          <Button variant="primary" size="m" icon={<div>IC</div>} />
          <Button variant="primary" size="s" icon={<div>IC</div>} />
          <Button variant="primary" size="l" icon={<div>IC</div>} iconPlacement="right">
            Some text
          </Button>
          <Button variant="primary" size="m" icon={<div>IC</div>} iconPlacement="right">
            Some text
          </Button>
          <Button variant="primary" size="s" icon={<div>IC</div>} iconPlacement="right">
            Some text
          </Button>
        </div>
      </div>
    </div>
  );
};
